import { Branch } from "./branch";
import { OrderLineType } from "./order";

export interface TposOrder {
  albaikIdentifier?: number | null;
  id: number;
  createdAt: number;
  feesTotal: number;
  itemsSubtotal: number;
  itemsTax: number;
  itemsTotal: number;
  backupPin: string;
  status: string;
  taxPercent: number;
  total: number;
  deliveryMethod: string;
  branch: Branch;
  fees: any[];
  items: OrderLineType[];
}

export interface AggregatorOrder {
  albaikIdentifier: number;
  createdAt: number;
  branch: Branch;
  items: OrderLineType[];
}
